module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-pride-medium-fd261788f58760ec4848fd8d449c3b0b.jpg";